export const VAULT_USER_PREFERENCES_STORAGE_KEY = 'user_preferences';

export const VAULT_TABLE_PAGE_SIZE_OPTIONS = [10, 25, 50, 100] as const;

export const VAULT_DEFAULT_ITEMS_PER_PAGE = 50;

export const VAULT_TABLE_PAGINATION_UPDATED_EVENT = 'vault-table-pagination-updated';

export const VAULT_TABLE_PAGINATION_LABELS = {
  itemsPerPage: 'Registros por página:',
  nextPage: 'Siguiente página',
  previousPage: 'Página anterior',
  firstPage: 'Primera página',
  lastPage: 'Última página',
  ofLabel: 'de',
} as const;

export function clampVaultTablePageSize(
  size: number,
  fallback: number = VAULT_DEFAULT_ITEMS_PER_PAGE,
): number {
  const n = Number(size);
  if (!Number.isFinite(n) || n <= 0) return fallback;
  const options = VAULT_TABLE_PAGE_SIZE_OPTIONS as readonly number[];
  if (options.includes(n)) return n;
  return options.reduce((best, candidate) =>
    Math.abs(candidate - n) < Math.abs(best - n) ? candidate : best,
  );
}

export function readVaultItemsPerPageFromPreferences(): number {
  if (typeof localStorage === 'undefined') {
    return VAULT_DEFAULT_ITEMS_PER_PAGE;
  }
  const raw = localStorage.getItem(VAULT_USER_PREFERENCES_STORAGE_KEY);
  if (!raw) return VAULT_DEFAULT_ITEMS_PER_PAGE;
  try {
    const prefs = JSON.parse(raw) as { items_per_page?: unknown };
    return clampVaultTablePageSize(Number(prefs.items_per_page));
  } catch {
    return VAULT_DEFAULT_ITEMS_PER_PAGE;
  }
}

export function notifyVaultTablePaginationPreferenceUpdated(
  pageSize: number = readVaultItemsPerPageFromPreferences(),
): void {
  if (typeof globalThis.window === 'undefined') return;
  globalThis.window.dispatchEvent(
    new CustomEvent(VAULT_TABLE_PAGINATION_UPDATED_EVENT, {
      detail: { pageSize: clampVaultTablePageSize(pageSize) },
    }),
  );
}
